(function() {
    
    var selectors = {
        siteFooter: '.site-footer',
        currencyFooter: '.currency-footer',
        currencySelector: '.locale-selectors__container',
        
    };
  
    var siteFooter = document.querySelector(selectors.siteFooter);
    var currencyFooter = document.querySelector(selectors.currencyFooter);
    var currencySelector = "";

    if ((siteFooter) && (currencyFooter)) {

        // currencyInterval = setInterval(function(){
        //     if(currencySelector) {
        //         clearInterval(currencyInterval);
        //         // console.log("apparso")
        //     } else {
        //         // console.log("in caricamento")
        //         currencySelector = document.querySelector(selectors.currencySelector);
        //         if(currencySelector){currencyFooter.appendChild(currencySelector)}
        //     }
        // },100);

    }
  
})();
  